var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.791667,
    y: 0.791667,
    width: 55.4167,
    height: 55.4167,
    rx: 27.7083,
    stroke: "#EAEAEA",
    strokeWidth: 1.58333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 31.1616L19.1844 40.4772C18.8359 40.8257 18.3923 41 17.8536 41C17.315 41 16.8714 40.8257 16.5228 40.4772C16.1743 40.1286 16 39.685 16 39.1464C16 38.6077 16.1743 38.1641 16.5228 37.8156L25.8384 28.5L16.5228 19.1844C16.1743 18.8359 16 18.3923 16 17.8536C16 17.315 16.1743 16.8714 16.5228 16.5228C16.8714 16.1743 17.315 16 17.8536 16C18.3923 16 18.8359 16.1743 19.1844 16.5228L28.5 25.8384L37.8156 16.5228C38.1641 16.1743 38.6077 16 39.1464 16C39.685 16 40.1286 16.1743 40.4772 16.5228C40.8257 16.8714 41 17.315 41 17.8536C41 18.3923 40.8257 18.8359 40.4772 19.1844L31.1616 28.5L40.4772 37.8156C40.8257 38.1641 41 38.6077 41 39.1464C41 39.685 40.8257 40.1286 40.4772 40.4772C40.1286 40.8257 39.685 41 39.1464 41C38.6077 41 38.1641 40.8257 37.8156 40.4772L28.5 31.1616Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.96a97750c685d9074c2860b1c0a4d787.svg";
export { ForwardRef as ReactComponent };